/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Form } from '@ant-design/compatible';
import { Select, Button, Input } from 'antd';
import { Erase } from '@carbon/icons-react';
import { UserRole } from '../../../types/types';

import './filterForm.css';

function userFilterForm() {
    const { form, userTabFilters, divisions } = this.props;
    const { getFieldDecorator } = form;

    return (
        <Form
            onSubmit={(this.handleSubmit)}
            className="login-form"
            layout="vertical"
        >
            <Form.Item label="User name">
                {getFieldDecorator('name', {
                    initialValue: userTabFilters?.name || null,
                })(
                    <Input placeholder="Enter Username" />
                )}
            </Form.Item>

            <Form.Item label="Email">
                {getFieldDecorator('email', {
                    initialValue: userTabFilters?.email || null,
                })(
                    <Input placeholder="Enter Email" />
                )}
            </Form.Item>

            <Form.Item label="Status">
                {getFieldDecorator('status', {
                    initialValue: userTabFilters?.status || 'all',
                })(
                    <Select placeholder="Select Status">
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value="0">Inactive</Select.Option>
                        <Select.Option value="1">Active</Select.Option>
                    </Select>
                )}
            </Form.Item>

            <Form.Item label="Role">
                {getFieldDecorator('role', {
                    initialValue: userTabFilters?.role || 'all',
                })(
                    <Select placeholder="Select Role">
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value={UserRole.User}>User</Select.Option>
                        <Select.Option value={UserRole.Manager}>Manager</Select.Option>
                        <Select.Option value={UserRole.Admin}>Admin</Select.Option>
                        <Select.Option value={UserRole.SalesAdmin}>Sales Admin</Select.Option>
                        <Select.Option value={UserRole.SuperAdmin}>Super Admin</Select.Option>
                    </Select>
                )}
            </Form.Item>

            <Form.Item label="Division">
                {getFieldDecorator('divisions', {
                    initialValue: userTabFilters?.divisions || null,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Division"
                        allowClear={<Erase size={12} />}
                        showSearch
                    >
                        {divisions.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </Form.Item>

            <div className="mt-2 mb-1 text-center">
                <Button
                    htmlType="submit"
                    type="primary"
                >
                    Filter
                </Button>
            </div>
        </Form>
    );
}

export { userFilterForm };
